import {
  ModalContent as ChakraModalContent,
  type ModalContentProps as ChakraModalContentProps,
  ModalOverlay,
  forwardRef,
} from '@chakra-ui/react';
import { mergeRefs } from '@chakra-ui/react-utils';
import { useMemo, useRef } from 'react';

import { OverlayContainerRefContextProvider } from '../OverlayContainerRefContext';

export type ModalContentProps = ChakraModalContentProps;

export const ModalContent = forwardRef<ModalContentProps, 'section'>(
  ({ children, ...restProps }, forwardedRef) => {
    const containerRef = useRef(null);
    const mergedRefs = mergeRefs(forwardedRef, containerRef);

    const containerRefContextValue = useMemo(
      () => ({
        containerRef,
      }),
      [containerRef],
    );

    return (
      <>
        <ModalOverlay />
        <ChakraModalContent ref={mergedRefs} {...restProps}>
          <OverlayContainerRefContextProvider value={containerRefContextValue}>
            {children}
          </OverlayContainerRefContextProvider>
        </ChakraModalContent>
      </>
    );
  },
);
ModalContent.displayName = 'ModalContent';
